import React, { useState } from "react";

const FOLDER_ICONS = ["📂", "🗂️"];

const FOLDER_COLORS = [
  { bg: "#FFF3E0", border: "#FF9800", text: "#E65100" },
  { bg: "#E8F5E8", border: "#4CAF50", text: "#2E7D32" },
  { bg: "#E3F2FD", border: "#2196F3", text: "#1565C0" },
  { bg: "#F3E5F5", border: "#9C27B0", text: "#7B1FA2" },
  { bg: "#FFF9C4", border: "#FFEB3B", text: "#F57F17" },
  { bg: "#FFEBEE", border: "#F44336", text: "#C62828" },
  { bg: "#F1F8E9", border: "#8BC34A", text: "#558B2F" },
  { bg: "#E0F2F1", border: "#009688", text: "#00695C" },
];

const AddAlbumModal = ({ isVisible, onClose, onSubmit }) => {
  const [albumName, setAlbumName] = useState("");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [selectedIcon, setSelectedIcon] = useState(FOLDER_ICONS[0]);
  const [selectedColor, setSelectedColor] = useState(FOLDER_COLORS[0]);
  const [error, setError] = useState("");

  if (!isVisible) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!albumName.trim()) return setError("Album name is required");
    if (!/^\d{4}$/.test(year)) return setError("Year must be 4 digits");

    onSubmit({
      title: albumName,
      year,
      icon: selectedIcon,
      color: selectedColor.bg,
      borderColor: selectedColor.border,
      textColor: selectedColor.text,
    });

    // Reset form
    setAlbumName("");
    setYear(new Date().getFullYear().toString());
    setSelectedIcon(FOLDER_ICONS[0]);
    setSelectedColor(FOLDER_COLORS[0]);
    setError("");
    onClose();
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 shadow-sm border-0">
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title fw-semibold">Add New Album</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-2">
              {error && <div className="alert alert-danger">{error}</div>}
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Album Name *</label>
                  <input
                    type="text"
                    className="form-control rounded-3"
                    value={albumName}
                    onChange={(e) => setAlbumName(e.target.value)}
                    placeholder="Enter album title"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Year *</label>
                  <input
                    type="text"
                    className="form-control rounded-3"
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    maxLength="4"
                    placeholder="2025"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Select Icon</label>
                  <div className="d-flex gap-3">
                    {FOLDER_ICONS.map((icon, index) => (
                      <button
                        type="button"
                        key={index}
                        className={`btn p-2 border ${
                          selectedIcon === icon
                            ? "border-dark shadow-sm"
                            : "border-light"
                        } rounded-2`}
                        style={{ width: 45, height: 45, fontSize: 24 }}
                        onClick={() => setSelectedIcon(icon)}
                      >
                        {icon}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Select Color Theme
                  </label>
                  <div className="d-flex flex-wrap gap-2">
                    {FOLDER_COLORS.map((color, index) => (
                      <button
                        type="button"
                        key={index}
                        className={`rounded-2 ${
                          selectedColor === color
                            ? "border-dark shadow-sm"
                            : "border-light"
                        }`}
                        style={{
                          backgroundColor: color.bg,
                          borderColor: color.border,
                          width: 40,
                          height: 40,
                          borderWidth: selectedColor === color ? "2px" : "1px",
                        }}
                        onClick={() => setSelectedColor(color)}
                      >
                        {selectedColor === color && (
                          <span style={{ fontSize: "18px", color: "#000" }}>
                            ✓
                          </span>
                        )}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary me-2 px-4"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary px-4"
                    style={{ backgroundColor: "#3b82f6", borderColor: "#3b82f6" }}
                  >
                    Add Album
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAlbumModal;
